import React from "react";
import { useNavigate } from "react-router-dom";
import { SERVICES_DATA } from "../data/services";
import handImg from "../assets/images/hand_surgery.png"; // fallback
import "../styles/service.css";
import SeoHead from "../components/SeoHead";

export default function ServicesPage() {
  const navigate = useNavigate();

  return (
    React.createElement(React.Fragment, null,
      React.createElement(SeoHead, {
        title: "Hand & Wrist Surgery Services in Hyderabad | Dr. R. Suneel",
        description: "Comprehensive hand, wrist and nerve surgery services in Hyderabad. Fractures, tendon repairs, wrist arthroscopy and peripheral nerve procedures by Dr. R. Suneel.",
        url: "https://www.handandwristclinics.com/services",
        image: "https://www.handandwristclinics.com/static/media/hand_surgery.png"
      }),

      React.createElement("section", { className: "section section-cream" },
        React.createElement("div", { className: "container" },

          React.createElement("h1", { className: "service-page-title" }, "Hand & Wrist Surgery Services in Hyderabad"),
          React.createElement("span", { className: "section-tag" }, "Our Specialities"),
          React.createElement("h2", { className: "section-title" }, "Specialized Surgical ", React.createElement("em", null, "Centres")),
          React.createElement("div", { className: "divider" }),

          React.createElement("p", { className: "section-sub", style: { marginBottom: "56px" } },
            "Dedicated centres for advanced subspecialty treatment, each offering focused expertise and state-of-the-art facilities."
          ),

          SERVICES_DATA.map((s, i) => (
            React.createElement("div", {
              key: i,
              onClick: () => navigate(s.route),
              style: {
                background: "white",
                borderRadius: "20px",
                overflow: "hidden",
                border: "1.5px solid var(--border)",
                marginBottom: "28px",
                boxShadow: "var(--shadow-sm)",
                cursor: "pointer",
                transition: "0.3s ease"
              },
              onMouseEnter: (e) => (e.currentTarget.style.transform = "translateY(-5px)"),
              onMouseLeave: (e) => (e.currentTarget.style.transform = "translateY(0)"),
            },
              React.createElement("div", { style: { display: "grid", gridTemplateColumns: "0.9fr 1.5fr" } },
                React.createElement("div", { style: { overflow: "hidden", minHeight: "280px" } },
                  React.createElement("img", {
                    src: s.img || handImg,
                    alt: s.title,
                    style: { width: "100%", height: "100%", objectFit: "cover" }
                  })
                ),

                React.createElement("div", { style: { padding: "40px 48px" } },
                  React.createElement("div", { style: { display: "flex", alignItems: "center", gap: "12px", marginBottom: "14px" } },
                    React.createElement("span", { style: { fontSize: "2rem" } }, s.icon),
                    React.createElement("h3", { style: { fontFamily: "'Cormorant Garamond',serif", fontSize: "1.5rem", color: "var(--navy)", fontWeight: 700 } }, s.title)
                  ),

                  React.createElement("p", { style: { color: "var(--indigo)", fontSize: "0.78rem", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "14px" } }, s.subtitle),

                  React.createElement("p", { style: { color: "var(--muted)", lineHeight: 1.75, marginBottom: "28px", fontSize: "0.9rem" } }, s.desc),

                  React.createElement("div", { style: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px" } },
                    React.createElement("div", null,
                      React.createElement("h5", { style: { fontSize: "0.72rem", letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--indigo)", fontWeight: 700, marginBottom: "12px" } }, "Conditions Treated"),
                      React.createElement("ul", { style: { listStyle: "none", display: "grid", gap: "7px" } },
                        s.conditions.map((c, j) => (
                          React.createElement("li", { key: j, style: { fontSize: "0.84rem", color: "var(--text)", display: "flex", alignItems: "center", gap: "9px" } },
                            React.createElement("span", { style: { width: 6, height: 6, background: "var(--gold)", borderRadius: "50%", flexShrink: 0 } }),
                            c
                          )
                        ))
                      )
                    ),

                    React.createElement("div", null,
                      React.createElement("h5", { style: { fontSize: "0.72rem", letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--indigo)", fontWeight: 700, marginBottom: "12px" } }, "Procedures"),
                      React.createElement("ul", { style: { listStyle: "none", display: "grid", gap: "7px" } },
                        s.procedures.map((p, j) => (
                          React.createElement("li", { key: j, style: { fontSize: "0.84rem", color: "var(--text)", display: "flex", alignItems: "center", gap: "9px" } },
                            React.createElement("span", { style: { width: 6, height: 6, background: "var(--indigo)", borderRadius: "50%", flexShrink: 0 } }),
                            p
                          )
                        ))
                      )
                    )
                  )
                )
              )
            )
          )),

          React.createElement("div", { style: { textAlign: "center", marginTop: "48px" } },
            React.createElement("button", { className: "btn-gold", onClick: () => navigate("/contact") }, "Book Consultation")
          )
        )
      )
    )
  );
}
